import { render, staticRenderFns } from "./Cross-platform.vue?vue&type=template&id=4b415d73&scoped=true&"
import script from "./Cross-platform.vue?vue&type=script&lang=js&"
export * from "./Cross-platform.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b415d73",
  null
  
)

export default component.exports